import * as THREE from "three";
import Experience from "../Experience.js";
import Environment from "./Environment.js";
import Floor from "./Floor.js";
import SamirBasicTurn from "./SamirBasicTurn.js";
import SamirBasicTurn2 from "./SamirBasicTurn2.js";

export default class World {
  constructor() {
    this.experience = new Experience();
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    console.log("hello");

    // Wait for resources
    this.ready = false;
    this.resources.on("ready", () => {
      // Setup
      console.log("resources ready");
      this.floor = new Floor();
      this.axesHelper = new THREE.AxesHelper(5);
      this.scene.add(this.axesHelper);
      this.environment = new Environment();
      // this.samirBasicTurn = new SamirBasicTurn();
      this.samirBasicTurn2 = new SamirBasicTurn2();

      this.ready = true;
    });
  }
  update() {
    if (this.ready) {
      // this.samirBasicTurn.tick();
      this.samirBasicTurn2.tick();
    }
  }
}
